import { useEffect, useState } from 'react';

/**
 * Below this width the window is a phone's: the suite's one phone breakpoint, `(max-width: 767px)`
 * (the responsive pass, 2026-10-26), which the kit's sheets and floating Ask button use too. It was
 * 601, the dock's own compact layout (phone direction 5, 2026-10-06), which left 601–767 px with the
 * laptop's drawers and rail.
 */
export const PHONE_WIDTH = 768;

/** The same breakpoint as a media query, for CSS-shaped checks outside React. */
export const PHONE_QUERY = '(max-width: 767px)';

/** Whether the window is phone-sized right now. */
export function isPhone(): boolean {
  return typeof window !== 'undefined' && window.innerWidth < PHONE_WIDTH;
}

/** Whether the window is phone-sized now, kept current as it is turned or resized. */
export function usePhone(): boolean {
  const [phone, setPhone] = useState(isPhone);
  useEffect(() => {
    const check = () => setPhone(isPhone());
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return phone;
}
